(() => {
  if (window.cartExtrasInitialized) return;
  window.cartExtrasInitialized = true;

  const extraMarker = '_cart_extra';
  let messageTimer;

  const getCart = () => fetch(`${routes.cart_url}.js`).then((response) => response.json());
  const refreshCart = (cartData) => {
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-extras', cartData });
    const cartBubble = document.getElementById('cart-icon-bubble');
    if (cartBubble) {
      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
        .then((response) => response.text())
        .then((html) => {
          const updatedBubble = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
          if (updatedBubble) cartBubble.innerHTML = updatedBubble.innerHTML;
        })
        .catch(() => {});
    }
  };
  const request = (url, body) => fetch(url, { ...fetchConfig(), body: JSON.stringify(body) }).then((response) => response.json());
  const itemFor = (cart, type) => cart.items.find((item) => item.properties && item.properties[extraMarker] === type);

  async function setExtra(toggle) {
    const type = toggle.dataset.extraType === 'greeting' ? 'Greeting card' : 'Packing and Gifting';
    const wantsItem = toggle.checked;
    const container = toggle.closest('[data-cart-extras]');
    container.classList.add('cart-extras--loading');
    try {
      const cart = await getCart();
      const selected = itemFor(cart, type);
      if (type === 'Packing and Gifting') {
        const packaging = cart.items.filter((item) => item.properties && item.properties[extraMarker] === type);
        await Promise.all(packaging.map((item) => request(routes.cart_change_url, { id: item.key, quantity: 0 })));
      } else if (selected) {
        await request(routes.cart_change_url, { id: selected.key, quantity: wantsItem ? selected.quantity : 0 });
      }
      if (wantsItem && (!selected || type === 'Packing and Gifting')) {
        await request(routes.cart_add_url, {
          items: [{ id: Number(toggle.dataset.variantId), quantity: 1, properties: { [extraMarker]: type } }],
        });
      }
      refreshCart(await getCart());
    } catch (error) {
      toggle.checked = !wantsItem;
      console.error('Unable to update cart extra.', error);
    } finally {
      container.classList.remove('cart-extras--loading');
    }
  }

  async function saveMessage(textarea) {
    const type = textarea.dataset.extraType === 'greeting' ? 'Greeting card' : 'Packing and Gifting';
    try {
      const cart = await getCart();
      const item = itemFor(cart, type);
      if (!item) return;
      await request(routes.cart_change_url, {
        id: item.key,
        quantity: item.quantity,
        properties: { ...item.properties, [textarea.dataset.propertyName]: textarea.value },
      });
    } catch (error) {
      console.error('Unable to save cart extra message.', error);
    }
  }

  document.addEventListener('change', (event) => {
    const toggle = event.target;
    if (!toggle.matches('[data-cart-extra-toggle]')) return;
    if (toggle.type === 'radio' && toggle.checked) {
      const group = toggle.closest('.cart-extra__options');
      if (group) {
        group.querySelectorAll('[data-cart-extra-toggle][data-extra-type="packaging"]').forEach((radio) => {
          if (radio !== toggle) radio.checked = false;
        });
      }
    }
    setExtra(toggle);
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-extra-message-button]');
    if (!button) return;
    const textarea = button.nextElementSibling;
    textarea.hidden = false;
    button.hidden = true;
    textarea.focus();
  });
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-cart-extra-message]')) return;
    clearTimeout(messageTimer);
    messageTimer = setTimeout(() => saveMessage(event.target), 400);
  });
})();
